import { SET_STATE, RESET, WORKOUT_TOGETHER_REQUEST, END_POINT, ADD_WORKOUTS } from './actionTypes'
import { setDockToSide, toggleMoreActions, sendEndPointMessage, showAlreadyOnCall, toggleShareScreen } from '../../redux/otuVision/actions'


export function setState ( newState ) {
  return { type : SET_STATE, newState }
}

export function reset () {
  return { type : RESET }
}

export function showChooseWorkout() {
  
  return (dispatch, getState) => {
  
    const state = getState()

    dispatch( fetchWorkouts() )

    dispatch( { 
        type : SET_STATE, 
        newState : { 
          visible : true,
          chooseWorkout: true 
        } 
      } 
    )

    dispatch( toggleMoreActions( false ) )

  
  }

}

export function closeChooseWorkout() {
  
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          visible : state.workoutTogether.workingOut,
          chooseWorkout: false 
        } 
      } 
    )
  
  }

}

export function sendWorkoutTogetherRequest( workout ) {

  return (dispatch, getState) => {
  
    const state = getState()


    dispatch( sendEndPointMessage( 
        { 
          target : END_POINT,
          action : WORKOUT_TOGETHER_REQUEST,
          workout

         }, 
        Object.values( state.otuVision.participants) 
      ) 
    )

    dispatch ( showWorkout( workout ) )

  }

}

export function receiveEndPointMessage( message ) {

  return ( dispatch, getState ) => {
    console.log( message )

    switch ( message.payload.action ) {
      case WORKOUT_TOGETHER_REQUEST:

        dispatch ( showWorkout( message.payload.workout ) )

    }

  }
}

export function showWorkout( workout ) {
  
  return ( dispatch, getState ) => {

    const state = getState()

    if ( state.otuVision.screenShared ) {
      dispatch( toggleShareScreen() )
    }

    dispatch( setDockToSide( true ) )

    dispatch( { 
        type : SET_STATE, 
        newState : { 
          visible : true,
          workout : workout,
          chooseWorkout : false,
          workingOut: true 
        } 
      } 
    )

    const url = otuApp.appState.rootUrl +  workout.link + '&gymWorkout=1'
    otuApp.triggerAjaxGet( url ,  
      { "attr" : { "data-hide-template-position" : "columns-all" } } )
  }

}

export function workoutEnded ( options ) {
  return ( dispatch, getState ) => {

    const state = getState()

    if ( state.otuVision.isGym ) {
      console.log('workoutTogether - Gym Ended')
      const url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=goToStep&step=872'
      otuApp.triggerAjaxGet( url ,  
        { "attr" : { "data-hide-template-position" : "columns-all" } } )
    } else {
      console.log('workoutTogether - Ended')
      const url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=goToProfile'
      otuApp.triggerAjaxGet( url ,  
        { "attr" : { "data-hide-template-position" : "columns-all" } } )
      dispatch( setDockToSide( false ) )
    }

  }
}


export function fetchWorkouts( options ) {
  return ( dispatch, getState ) => {
    console.log('workoutTogether - fetchingWorkouts')

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=gym.getWorkouts',{},{
      responseType : 'json',
      noSysInteraction : true,
      callback : function ( workouts ) {

        dispatch( { 
          type : ADD_WORKOUTS, 
          workouts
        } )
      }
    } )


  }
}

